import RedactionSearchResultContainer from './RedactionSearchResultContainer';

export default RedactionSearchResultContainer;